module.exports = __webpack_public_path__ + "img/yuyue.ec9291a3.png";